import { useRouter } from 'next/router';
import Image from 'next/image';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Link } from '~/components/global';
import useUser from '~/lib/user';
import useSumoDay from '~/lib/util/sumoDay';
import { useExperiment } from '~/lib/experiment';
import { ASKSUMO_CLEANUP_EXPERIMENT_NAME } from '~/lib/util/constants';
import { NavItemProps } from '~/types/layout';

import CommentDotsGradient from '../../../public/comment-dots-gradient.svg';

function AskSumoNavItem() {
  const router = useRouter();
  const { user } = useUser();
  const { isSumoDay } = useSumoDay();
  const { variant } = useExperiment(ASKSUMO_CLEANUP_EXPERIMENT_NAME);

  if (variant !== 'enabled') {
    return null;
  }

  return (
    <li
      key="asksumo"
      className="my-2 mr-8 md:my-0 md:flex md:h-full md:items-center"
    >
      <Link
        href="/asksumo/"
        className={clsx(
          'truncate font-header text-xl font-semibold',
          'md:font-sans md:text-base md:font-normal',
          'border-b-2 border-transparent pb-4 pt-3 leading-6 md:hover:border-blue-500',
          { 'md:border-blue-500': router.asPath.indexOf('/asksumo/') === 0 },
        )}
      >
        <Image
          src={CommentDotsGradient}
          width="25"
          alt=""
          role="presentation"
          className="mr-1.5 inline-block"
        />
        AskSumo
        {!user && !isSumoDay && <span>&nbsp;and get 10% off</span>}
      </Link>
    </li>
  );
}

export default function NavGroups({
  navItems,
}: {
  navItems: Array<NavItemProps>;
}) {
  const router = useRouter();
  const { asPath } = router;
  return (
    <div className="w-full grow md:w-auto">
      <ul className="flex flex-col md:h-full md:flex-row md:items-center">
        {navItems.map((item: NavItemProps) => (
          <li
            key={item.href}
            className="my-2 mr-8 md:my-0 md:flex md:h-full md:shrink-0 md:items-center"
          >
            <Link
              key={item.href}
              href={item.href}
              className={clsx(
                'font-header text-xl font-semibold',
                'md:font-sans md:text-base md:font-normal',
                'border-b-2 border-transparent pb-4 pt-3 leading-6 md:hover:border-bolt',
                { 'md:border-bolt': asPath.indexOf(item.href) === 0 },
              )}
            >
              {item.icon && (
                <FontAwesomeIcon
                  icon={item.icon.src}
                  className={item.icon.className}
                />
              )}
              {item.name}
            </Link>
          </li>
        ))}

        <AskSumoNavItem />
      </ul>
    </div>
  );
}
